// Staging environment. Exchange (VAST) and EPG endpoints are shared with dev for now; Auth0 and
// serviceUrl are staging-specific.
//
// `production` is deliberately false (same as QA): inline ternaries in creative-designer and
// creative-studio services route video preview to prod Moments when true.
export const environment = {
  production: false,
  serviceUrl: 'https://api-staging-dx.revyrie.co',
  vastUrl: 'https://dev-x.videobyte.com',
  epgGenresService: 'https://dev-epg.videobyte.com/main/api/genre',
  epgKeywordsService: 'https://dev-epg.videobyte.com/main/api/keyword',
  auth0: {
    domain: 'dev-ddbxu05mz0xpba8n.us.auth0.com',
    clientId: 'wLnbQiCQbn9jjs3FkDykdKuVzXOaRhhk',
    audience: 'https://api.dxkulture.com',
  },
};
